import prod1 from './assets/prod1.png';
import prod2 from './assets/prod2.png';
import prod3 from './assets/prod3.png';
import prod4 from './assets/prod4.png';

const cats=[
    {
        "id": "00230720-1220-43a8-a0ee-2e66afb591c7",
        "name": "Women",
        "description": "",
        "image": "https://firebasestorage.googleapis.com:443/v0/b/piti-commerce.appspot.com/o/commerce%2Fsneakerguys%2Fcategories%2F-NucX80YbJWi1Ou4lCJO?alt=media&token=56993536-c243-421e-a7cd-c9a8983a7d27",
        "active": true,
        "order": 1,
        "parent_category_id": null,
        "sub_categories": []
    },
    {
        "id": "03774cae-5b3e-4a20-afde-74fe51d725bf",
        "name": "Size- 45",
        "description": "",
        "image": "https://firebasestorage.googleapis.com:443/v0/b/piti-commerce.appspot.com/o/commerce%2Fsneakerguys%2Fcategories%2F-Nu3Ip0zIIxzGVq-Ne9u?alt=media&token=4cd26c72-4e34-4dd5-8127-0c3da0ad8e6f",
        "active": true,
        "order": 1,
        "parent_category_id": null,
        "sub_categories": []
    },
    {
        "id": "1f7be506-278b-4d94-9f1f-818d86dee211",
        "name": "Size- 44",
        "description": "",
        "image": "https://firebasestorage.googleapis.com:443/v0/b/piti-commerce.appspot.com/o/commerce%2Fsneakerguys%2Fcategories%2F-Nu3diKlw3hWSozMqzBl?alt=media&token=48a63365-0c83-4fde-8392-5072de3dad01",
        "active": true,
        "order": 1,
        "parent_category_id": null,
        "sub_categories": []
    },
    {
        "id": "650cafe0-8d43-4feb-a245-f1ebdcfe41d1",
        "name": "Youth & Teen Age 8-16 Years",
        "description": "",
        "image": "https://firebasestorage.googleapis.com:443/v0/b/piti-commerce.appspot.com/o/commerce%2Fsneakerguys%2Fcategories%2F-Nu9nK69AON2fBtCXp3D?alt=media&token=1dfc7a21-e9c5-41ac-91c8-9c51beaa05c3",
        "active": true,
        "order": 1,
        "parent_category_id": null,
        "sub_categories": []
    },
    {
        "id": "6da352e1-e919-40b1-9e65-d907ae41528b",
        "name": "Kids Age 0-3 Years",
        "description": "",
        "image": "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/commerce%2Fsneakerguys%2Fcategories%2F-NtjJSB5N5OeBwqy5zHy?alt=media&token=4aae3feb-67e4-4fb3-9b72-b393369629a4",
        "active": true,
        "order": 1,
        "parent_category_id": null,
        "sub_categories": []
    },
    {
        "id": "792449ff-37f6-4229-824f-6d3a7b77e4a0",
        "name": "Size- 41",
        "description": "",
        "image": "https://firebasestorage.googleapis.com:443/v0/b/piti-commerce.appspot.com/o/commerce%2Fsneakerguys%2Fcategories%2F-Nu3Bc5wh8u80crxWAur?alt=media&token=6528b7c2-a8c9-4d7a-b472-be7ff250ac36",
        "active": true,
        "order": 1,
        "parent_category_id": null,
        "sub_categories": []
    },
    {
        "id": "95f3a68e-26c4-4d78-b3a3-182d2630bbc3",
        "name": "Size- 39",
        "description": "",
        "image": "https://firebasestorage.googleapis.com:443/v0/b/piti-commerce.appspot.com/o/commerce%2Fsneakerguys%2Fcategories%2F-NuE4tLAl8GD_rKl_RNw?alt=media&token=f30a3f3e-482f-4105-9fd2-5871bef86a61",
        "active": true,
        "order": 1,
        "parent_category_id": null,
        "sub_categories": []
    },
    {
        "id": "aa5e627b-276c-48aa-9c0a-722335c765df",
        "name": "Size- 42",
        "description": "",
        "image": "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/commerce%2Fsneakerguys%2Fcategories%2F-NtjJMzv1vjRVfefhYYo?alt=media&token=b5a443a7-7d66-424a-b552-f88529c4317a",
        "active": true,
        "order": 1,
        "parent_category_id": null,
        "sub_categories": []
    },
    {
        "id": "ae79ce89-2675-4711-aec4-30ba0dccff8d",
        "name": "Kids Age 4-7 Years",
        "description": "",
        "image": "https://firebasestorage.googleapis.com:443/v0/b/piti-commerce.appspot.com/o/commerce%2Fsneakerguys%2Fcategories%2F-Nu9nFnm_hQOub67Muq2?alt=media&token=0b1786da-f01b-4b1a-bc9d-fc0676ca214f",
        "active": true,
        "order": 1,
        "parent_category_id": null,
        "sub_categories": []
    },
    {
        "id": "b6f57b92-0a8a-4459-89a5-54b492075bda",
        "name": "Discount Items",
        "description": "No Error",
        "image": "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/commerce%2Fsneakerguys%2Fcategories%2F-Ntp1vsA_E4P_gB4kl5s?alt=media&token=bfe0edc0-b86a-4e84-b2f2-0626315783cc",
        "active": true,
        "order": 1,
        "parent_category_id": null,
        "sub_categories": []
    },
    {
        "id": "bfc52622-8868-4bd7-a3e1-a9935b48f1f9",
        "name": "Size- 40",
        "description": "",
        "image": "https://firebasestorage.googleapis.com:443/v0/b/piti-commerce.appspot.com/o/commerce%2Fsneakerguys%2Fcategories%2F-Nu3JaQQ6Fl5f4z87Yxr?alt=media&token=4c630a90-1354-4839-a1db-2b74c6667d4d",
        "active": true,
        "order": 1,
        "parent_category_id": null,
        "sub_categories": []
    },
    {
        "id": "f2450c8a-1fd9-483e-8b08-afb8739c1874",
        "name": "Size- 43",
        "description": "",
        "image": "https://firebasestorage.googleapis.com:443/v0/b/piti-commerce.appspot.com/o/commerce%2Fsneakerguys%2Fcategories%2F-Nu3EIZXCXV9MYD-pXsU?alt=media&token=9975debd-8b62-40ab-b5b2-ac50c4d1911e",
        "active": true,
        "order": 1,
        "parent_category_id": null,
        "sub_categories": []
    },
    {
        "id": "f84642d1-2668-4fce-a9d6-abab1bc37247",
        "name": "Size- 47",
        "description": "",
        "image": "https://firebasestorage.googleapis.com:443/v0/b/piti-commerce.appspot.com/o/commerce%2Fsneakerguys%2Fcategories%2F-NuXmgXCY6VpNXCE14sj?alt=media&token=b2ffac81-1763-4e45-974d-f295e5d84faa",
        "active": true,
        "order": 1,
        "parent_category_id": null,
        "sub_categories": []
    }
]

export const categories = [
    {
        name: "Kids",
        subcategories: [
            {
                name: "Kids Age 0-3 Years",
                id: "#",
            },
            {
                name: "Kids Age 4-7 Years",
                id: "#"
            },
            {
                name: "Youth & Teen Age 8-16 Years",
                id: "#"
            },
        ],
    },
    {
        name: "Sizes",
        subcategories: [
            {
                name: "Size- 39",
                id: "",
            },
            {
                name: "Size- 40",
                id: "",
            },
            {
                name: "Size- 41",
                id: "#",
            },
            {
                name: "Size- 42",
                id: "#",
            },
            {
                name: "Size- 43",
                id: "#",
            },
            {
                name: "Size- 44",
                id: "#",
            },
            {
                name: "Size- 45",
                id: "#",
            },
            {
                name: "Size- 45",
                id: "#",
            },
        ],
    },
    {
        name: "Women",
        id: "",
        subcategories: [
        ]
    },

]

export const products = [
    {
        id: "one",
        name: "Nike AirMax 270 React",
        price: "20,000 MMK",
        image: prod1
    },
    {
        id: "two",
        name: "Nike Kyrie 5 Kids",
        price: "40,000 MMK",
        image: prod2
    },
    {
        id: "three",
        name: "Adidas Fatioo",
        price: "28,000 MMK",
        image: prod3,
    },
    {
        id: "four",
        name: "Adidas Superstar",
        price: "45,000 MMK",
        image: prod4,
    },

]

export const bannerImages = [
    { code: "sneakerguys_tmpl_img_1", image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FMen%20Banner%20(2056%20x%20768%20px).png?alt=media&token=3071e8af-7946-4f26-9679-ce5c29f7f3c5" },
    { code: "sneakerguys_tmpl_img_2", image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FWomen%20Banner%20(2560%20x%20800%20px).png?alt=media&token=e4b6d2ed-ce0c-4dd5-8ba3-e3035fbdab12" },
    { code: "sneakerguys_tmpl_img_3", image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FKids%20Banner.png?alt=media&token=4d14aecf-aad2-4bef-91f6-050a8778f1c1" },
]